import { id } from "date-fns/locale/id";

// ─── FORMATTERS ───────────────────────────────────────────────────────────────
export const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "–";

export const fmtMoney = (n, cur = "USD") =>
  n != null
    ? new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: cur,
        minimumFractionDigits: 0,
      }).format(n)
    : "–";

// ─── COLOR MAPS ───────────────────────────────────────────────────────────────
export const PC = {
  high: "bg-rose-100 text-rose-700",
  medium: "bg-amber-100 text-amber-700",
  low: "bg-emerald-100 text-emerald-700",
};

export const SC = {
  pending: "bg-amber-100 text-amber-700",
  in_progress: "bg-blue-100 text-blue-700",
  completed: "bg-emerald-100 text-emerald-700",
  cancelled: "bg-rose-100 text-rose-700",
  new: "bg-sky-100 text-sky-700",
  contacted: "bg-indigo-100 text-indigo-700",
  qualified: "bg-violet-100 text-violet-700",
  proposal_sent: "bg-orange-100 text-orange-700",
  converted: "bg-emerald-100 text-emerald-700",
  lost: "bg-rose-100 text-rose-700",
  planning: "bg-sky-100 text-sky-700",
  confirmed: "bg-emerald-100 text-emerald-700",
  ongoing: "bg-blue-100 text-blue-700",
  income: "bg-emerald-100 text-emerald-700",
  expense: "bg-rose-100 text-rose-700",
};

// ─── LEADS PIPELINE ───────────────────────────────────────────────────────────
export const PIPELINE = [
  "new",
  "contacted",
  "qualified",
  "proposal_sent",
  "converted",
  "lost",
];

export const PCOL = {
  new: "border-sky-400 bg-sky-50",
  contacted: "border-indigo-400 bg-indigo-50",
  qualified: "border-violet-400 bg-violet-50",
  proposal_sent: "border-orange-400 bg-orange-50",
  converted: "border-emerald-400 bg-emerald-50",
  lost: "border-rose-400 bg-rose-50",
};

// ─── TRIP STATUS GRADIENTS ────────────────────────────────────────────────────
export const SBGR = {
  planning: "from-sky-400 to-blue-500",
  confirmed: "from-emerald-400 to-teal-500",
  ongoing: "from-violet-400 to-purple-500",
  completed: "from-slate-400 to-slate-500",
  cancelled: "from-rose-400 to-red-500",
};

// ─── NAV CONFIG ───────────────────────────────────────────────────────────────
export const NAV = [
  { id: "dashboard", label: "Dashboard", icon: "dashboard" },
  { id: "clients", label: "Clients", icon: "clients" },
  { id: "trips", label: "Trips", icon: "trips" },
  { id: "tasks", label: "Tasks", icon: "tasks" },
  { id: "leads", label: "Leads", icon: "leads" },
  { id: "teams", label: "Teams", icon: "clients" },
  { id: "invoices", label: "Invoices", icon: "invoice" },
  { id: "receipts", label: "Receipts", icon: "invoice" },
  { id: "refunds", label: "Refunds", icon: "invoice" },
  { id: "reviews", label: "Reviews", icon: "star" },
  { id: "finances", label: "Finances", icon: "finances" },
];

// ─── ICON PATHS ───────────────────────────────────────────────────────────────
export const I = {
  dashboard:
    "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
  clients:
    "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z",
  trips:
    "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064",
  tasks:
    "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4",
  leads: "M13 10V3L4 14h7v7l9-11h-7z",
  finances:
    "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
  plus: "M12 4v16m8-8H4",
  close: "M6 18L18 6M6 6l12 12",
  edit: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z",
  trash:
    "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16",
  eye: "M15 12a3 3 0 11-6 0 3 3 0 016 0zM2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z",
  check: "M5 13l4 4L19 7",
  search: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z",
  bell: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9",
  arrowUp: "M5 15l7-7 7 7",
  menu: "M4 6h16M4 12h16M4 18h16",
  user: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
  calendar:
    "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
  plane: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8",
  logout:
    "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1",
  refresh:
    "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15",
  warn: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z",
  invoice:
    "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2M9 12h6m-6 4h4",

  receipts:
    "M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2zm0 0l2-2 2 2 2-2 2 2M9 9h6m-6 4h6",

  refunds: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6",
  star: "M11.48 3.5a.56.56 0 011.04 0l2.13 5.11a.56.56 0 00.48.35l5.52.44c.5.04.7.66.32.99l-4.2 3.6a.56.56 0 00-.18.56l1.28 5.39a.56.56 0 01-.84.61l-4.73-2.89a.56.56 0 00-.59 0l-4.72 2.89a.56.56 0 01-.84-.61l1.28-5.39a.56.56 0 00-.18-.56l-4.2-3.6a.56.56 0 01.32-.99l5.52-.44a.56.56 0 00.48-.35l2.13-5.11z",
};
